import { createContext, useContext } from 'react';
import { ICurationStatusDetails, IStudy } from '@vivli/features/studies/infrastructure/interface';
import { IUser } from '@vivli/shared/infrastructure/interface';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';
import { UseFormReturn } from 'react-hook-form';

interface IStudyContext {
    study: IStudy;
    user: IUser;
    usedIn: string;
    studyIpdPackageSubmitted: boolean;
    assignedAppType: AssignedAppTypeEnum;
    isSavingStudy: boolean;
    setActiveStudy: (study: IStudy) => void;
    handleFormSave: () => void;
    handleRemovePosting: () => void;
    handleSetupForNewIpdVersion: () => void;
    handleCreateDoiForIpdPackage: () => void;
    handleMaintainDois: () => void;
    handleDeleteIpdPackage: () => void;
    handleApproveStudy: () => void;
    handleRejectStudy: () => void;
    handleApproveCurationSubmit: () => void;
    handleUpdateAndStatusChange: (statusObject: ICurationStatusDetails, finalStep?: () => void) => void;
    handleDeleteStudy: () => void;
    documentsRefresh: number;
    setDocumentsRefresh: (value: number) => void;
    ipdRefresh: number;
    setIpdRefresh: (value: number) => void;
}

export const StudyContext = createContext<IStudyContext>(null);

export const useStudyContext = () => useContext(StudyContext);
